// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super {
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/test-components/component1/component1.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/src/app/test-components/component1/component1.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;ACCJ","sourcesContent":[".super{\r\n    height: 100px;\r\n}\r\n",".super {\n  height: 100px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
